import isEmpty from '../utils/isEmpty';

export const buildEmlFilename = (subject: Maybe<string>) => {
  const base = isEmpty(subject) ? 'email' : subject.trim();

  const sanitized = base
    .replace(/[\r\n]/g, ' ')
    .replace(/[<>:"/\\|?*]+/g, '_')
    .slice(0, 80);

  return `${sanitized}.eml`;
};
